<template>
  <tr class="cat-search-result-row">
    <td colspan="3">
      <p class="visible-for-small-only">
        <slot name="view-link"></slot>
      </p>
      <dl title="Company details">
        <template v-for="(item, idx) in fields" :key="idx + 1">
          <dt>{{ item.label }}</dt>
          <dd>{{ item.value }}</dd>
        </template>
      </dl>
      <slot name="detailed_actions"></slot>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatSearchResultsDetailRow",
  props: {
    fields: [Array]
  }
});
</script>
